// extracted by mini-css-extract-plugin
export var labelPadding = "index-module--labelPadding--2O7cB";
export var labelText = "index-module--labelText--3ieip";
export var container = "index-module--container--3XG1Y";